/**
 * This script updates the URL to reflect the selected product variant
 * and ensures the correct image is displayed based on the selected color variant.
 * It targets the variant options specifically within the fieldset with id="Color".
 */

function sanitizeColor(color) {
    return color.replace(/\s+/g, '-').replace(/&/g, '-').toLowerCase();
}

// Function to update images based on selected variant's color in the "Color" fieldset

function updateDisplayedImage() {
    const colorFieldset = document.querySelector('#Color');
    const selectedVariant = colorFieldset ? colorFieldset.querySelector('input.product__variant--button:checked') : null;

    if (selectedVariant) {
        // Get and sanitize the color from the selected variant's value
        const color = sanitizeColor(selectedVariant.value);
        
        // Gather all product gallery images
        const galleryImages = document.querySelectorAll('.product-gallery-desktop');
        let imageFound = false;

        galleryImages.forEach(image => {
            const altText = sanitizeColor(image.getAttribute('data-alt'));
            if (altText === color) {
                image.classList.remove('hidden'); // Show matching image
                imageFound = true;
            } else {
                image.classList.add('hidden'); // Hide non-matching images
            }
        });

        // If no matching image is found, display all images (or you could show a specific default image)
        if (!imageFound) {
            galleryImages.forEach(image => image.classList.remove('hidden'));
        }
    } else {
        // If no color selection is active, ensure all images are visible
        const galleryImages = document.querySelectorAll('.product-gallery-desktop');
        galleryImages.forEach(image => image.classList.remove('hidden'));
    }
}


// Function to update URL based on selected variant ID
function updateUrlWithVariant(variantId) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', newUrl);
}

// Updated function to handle both URL parameter and default checked variant in the "Color" fieldset
function updateVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    const colorFieldset = document.querySelector('#Color');

    if (!colorFieldset) return;

    if (variantId) {
        // Find the input matching the variant ID within the "Color" fieldset
        const matchingInput = colorFieldset.querySelector(`input.product__variant--button[idvalue="${variantId}"]`);
        if (matchingInput) {
            matchingInput.checked = true; // Set it as checked
            matchingInput.click(); // Trigger click to update the UI
        }
    } else {
        // If no variant is set in the URL, fall back to the default checked input
        const firstCheckedVariant = colorFieldset.querySelector('input.product__variant--button:checked');
        if (firstCheckedVariant) {
            updateDisplayedImage(); // Show only the corresponding image
        }
    }
}

function bindVariantButtonListeners() {
    const colorFieldset = document.querySelector('#Color');
    if (!colorFieldset || colorFieldset.dataset.variantUrlBound === 'true') return false;

    colorFieldset.dataset.variantUrlBound = 'true';
    colorFieldset.querySelectorAll('.product__variant--button').forEach(button => {
        button.addEventListener('change', function () {
            const variantId = this.getAttribute('idvalue');
            updateUrlWithVariant(variantId);
            updateDisplayedImage();
        });
    });

    return true;
}

// Call the function on page load to display the image matching the URL or default checked variant
document.addEventListener("DOMContentLoaded", () => {
    updateVariantFromUrl();
    updateDisplayedImage();

    if (!bindVariantButtonListeners()) {
        const bindInterval = setInterval(() => {
            if (bindVariantButtonListeners()) clearInterval(bindInterval);
        }, 100);

        setTimeout(() => clearInterval(bindInterval), 10000);
    }
});

// Check every 100ms to ensure the correct image is displayed based on selected color variant
setInterval(updateDisplayedImage, 100);

const isMobile = window.matchMedia("(max-width: 768px)");

function ColorMobile() {
  if (isMobile.matches) { // Only run on mobile
    const colorButtons = document.querySelectorAll("input[name='select-option2']");

    colorButtons.forEach((button) => {
      if (button.checked) {
        // Get the label associated with this input using the 'for' attribute
        const label = document.querySelector(`label[for='${button.id}']`);
        if (label) {
          // Create a synthetic click event
          const clickEvent = new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          label.dispatchEvent(clickEvent); // Dispatch the synthetic click event on the label
        }
      }
    });
  }
}

// Run the function with a slight delay after load
setTimeout(ColorMobile, 300);